import { FilterOptionInformation } from "@studyportals/search-filters";
import { continentsAll } from '@studyportals/static-domain-data/continents/continents';
import { continentGetPath } from '@studyportals/static-domain-data/continents/continent-get-path';
import { Continent } from '@/router/fragments/fragment-items/Continent';

class ContinentPresenter {

	public allWithPaths(): Continent[] {
		const continents: Continent[] = [];

		continentsAll.forEach((continent) => {
			const path = continentGetPath(continent.id);
			if (path === null) {
				return;
			}
			continents.push(new Continent(continent.id, path));
		});

		return continents;
	}

	public allOptions(): FilterOptionInformation[] {
		return continentsAll.map(continent => new FilterOptionInformation(
			continent.name,
			continent.id,
			continentGetPath(continent.id) ?? '',
			continent.name
		));
	}
}

const continentPresenterInstance = new ContinentPresenter();

export {
	continentPresenterInstance as ContinentPresenter
}
